<template>
  <div class="footer">
    <p class="p1">开封图书馆</p>
    <p>Copyright© 2017开封图书馆版权所有 豫公网安备 41020202000039</p>
    <p>服务支持：Copyright  新永源科技</p>
  </div>
</template>

<script>
import API from "../api/api_user";
export default {
  name: "Footer",
  props: {},
  data() {
    return {
      linkslist: ""
    };
  },
  methods: {
    // getLinks() {
    //   API.Links().then(res => {
    //     this.linkslist = res.data;
    //   });
    // },
  },
  mounted() {
    // this.getLinks();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  /* position: fixed; */
  bottom: 0px;
  width: 100%;
  height: auto;
  background-color: #f7f0e6;
  color: #767676;
  font-size: 12px;
  padding: 18px 0px;
  text-align: center;
  z-index: 999;
}
.footer .p1 a {
  text-decoration: none;
  color: #767676;
}
.footer .p1 a em {
  display: inline-block;
  padding: 6px;
  font-style: normal;
}
.footer .p3 {
  padding: 6px;
}
</style>
